// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2881":"css/app.6873","8614":"css/admin-app.6873"}[chunkId] + ".css";
};